<div *ngIf="isBusy" style="text-align: center">
  <h1>Please wait... &nbsp;<i class="fa fa-spinner fa-spin"></i></h1>
</div>

<ng-container *ngIf="!isBusy">
  <div *ngIf="organisationType == 2 || organisationType == 3 || organisationType == 4">
    <!-- if the supplier hasn't selected a sign-up type, show the signup component -->
    <div *ngIf="organisationType == 3 && !userOrg.supplierSignupTypeId; else boarding">
      <supplier-signup-type
        [organisation]="userOrg"
        (signupTypeSet)="onSupplierSignupTypeSet($event)"
      ></supplier-signup-type>
    </div>

    <ng-template #boarding>
      <boarding-check-list></boarding-check-list>
    </ng-template>
  </div>

  <div *ngIf="organisationType == 1">
    <engineius-homepage *ngIf="showEngineiusHomepage"></engineius-homepage>
    <dashboard-engineius-kpis-toplevel></dashboard-engineius-kpis-toplevel>
  </div>

  <div *ngIf="organisationType == 2 && boardingCheckList.isHide">
    <dashboard-customer></dashboard-customer>
  </div>

  <div *ngIf="organisationType == 3 && boardingCheckList.isHide">
    <dashboard-supplier></dashboard-supplier>
  </div>
</ng-container>
